import React from "react";
import { useField, useFormikContext } from "formik";

type EditSingleSelectReadOnlyProps = {
  name: string;
  dataSource: string | null;
};

export const EditSingleSelectReadOnly: React.FC<EditSingleSelectReadOnlyProps> = ({
  name,
  dataSource,
}) => {
  const [field] = useField<any>(name);
  const formik = useFormikContext<any>();

  // console.log("field.name: ", field.name);
  // console.log("field.value: ", field.value);

  return (
    <div className="EditBox ViewOnly SearchListRenderer Single">
      {field.value ? (
        Array.isArray(field.value) && field.value.length > 0 ? (
          field.value.map((id, i) => {
            return (
              <div className="Item" key={`item-${i}-${name}`}>
                \<div className="Label">{id !== null ? `${id}` : ""}</div>
              </div>
            );
          })
        ) : typeof field.value === "string" ? (
          <div className="Item" key={`item-${name}`}>
            <div className="Label">
              {field.value !== null ? `${field.value}` : ""}
            </div>
          </div>
        ) : (
          <div className="NoItemsData">{`No data`}</div>
        )
      ) : (
        <div className="NoItemsData">{`No data`}</div>
      )}
    </div>
  );
};
